import React, { useState, useEffect } from "react";

export default function HUDInfo({ stat, displayType, layoutType}){

    const [boxStyle, setBoxStyle] = useState({
        backgroundColor : ""
    });
    const [valueStyle, setValueStyle] = useState({
        color: "#FFF"
    });

    useEffect(() =>
    {
        //console.log("stat", stat);
        let flexGrow = "";
        if (layoutType===1)//GRID
        {
            flexGrow= 1
        }
        setBoxStyle({
            flexGrow
        });
        setValueStyle({
            color: "rgb(" + stat.color.r + "," + stat.color.g + "," + stat.color.b + ")"
        });
        return (() =>
        {
            
        })
    }, [stat, displayType, layoutType, setBoxStyle]);

    return (
        <div className="hud-box" style={boxStyle}>
            <div style={valueStyle}>{stat.value}</div>
        </div>
    )
}